<ul [attr.data-testid]="'flex-content-list'">
  <tree-content
    cdkDropListGroup
    [data]="flexEditorService.regularizedFlex.content.contents"
    [attr.data-testid]="'flex-tree-content'"
  >
  </tree-content>
</ul>
